import { SVGProps } from 'react';

const HyperlightOptics = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="63" height="63" x=".5" y=".5" fill="url(#a)" rx="31.5" />
    <rect width="63" height="63" x=".5" y=".5" stroke="#1F1F1F" rx="31.5" />
    <path
      fill="#fff"
      d="M19.874 29.363h6.474v-8.03h3.874v20h-3.874v-8.03h-6.474v8.03H16v-20h3.874v8.03ZM48 24.22v14.227l-2.794 2.886h-8.634l-2.794-2.886V24.22l2.794-2.886h8.634L48 24.22Zm-10.345 1.655v10.917l.58.599h5.311l.58-.6V25.876l-.58-.599h-5.311l-.58.6Z"
    />
    <defs>
      <linearGradient id="a" x1="64" x2="19.498" y1="0" y2="75.494" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1F1F1F" />
        <stop offset="1" stopColor="#141414" />
      </linearGradient>
    </defs>
  </svg>
);

export default HyperlightOptics;
